import { render, staticRenderFns } from "./SalesLedgerView.vue?vue&type=template&id=1a80a562&"
import script from "./SalesLedgerView.vue?vue&type=script&lang=js&"
export * from "./SalesLedgerView.vue?vue&type=script&lang=js&"
import style0 from "./SalesLedgerView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports